<template>
    <div>
        <div class="task-detail-card">
            <div class="d-flex align-items-center justify-content-between">
                <div class="">
                    <!-- <div class="row"> -->
                    <div class="d-flex">
                        <!-- <img
                            src="../assets/image/check.png"
                            alt="checkbox"
                            width="20"
                            height="20"
                            :class="[
                                (dayTask.link && dayTask.taskStatus === 'COMPLETED') ||
                                (dayTask.task.submissionType === 'SUBMIT' && dayTask.status)
                                    ? 'check-logo-completed'
                                    : 'check-logo-incompleted',
                                'ms-auto d-block',
                            ]"
                        /> -->
                        <font-awesome-icon icon="fa-solid fa-circle-check"  
                            :class="[
                                (dayTask.link && dayTask.taskStatus === 'COMPLETED') ? 'check-logo-green' : '',
                                (dayTask.link && dayTask.taskStatus === 'IN_REVIEW') ? 'check-logo-yellow' : '',
                                (dayTask.link && dayTask.taskStatus === 'REVERTED') ? 'check-logo-red' : '',
                                (dayTask.task.submissionType === 'LINK' && dayTask.taskStatus === 'NOT_YET_STARTED') ? 'check-logo-incompleted' : '',
                                (dayTask.task.submissionType === 'SUBMIT' && dayTask.status) ? 'check-logo-green' : '',
                                (dayTask.task.submissionType === 'SUBMIT' && !dayTask.status) ? 'check-logo-incompleted' : '',
                                'ms-auto d-block',
                            ]"/>
                        <div class="d-flex flex-row justify-content-between">
                            <div>
                                <p class="task-detail-title ms-2">{{ dayTask.task.title }}</p>
                            </div>
                            
                        </div>
                        <!-- <p class="task-detail-subtitle">Created at: {{ formatDate(dayTask.createdDate) }}</p> -->
                    </div>
                    <!-- </div> -->
                </div>
                <div class="d-flex gap-2 align-items-center">
                    <Badge
                                v-if="dayTask.taskStatus!='NOT_YET_STARTED'"
                                :label="dayTask.taskStatus.replaceAll('_',' ')"
                                :class="[
                                    dayTask.taskStatus === 'REVERTED' ? 'badge-neon badge-neon-error-outline' : '',
                                    dayTask.taskStatus === 'IN_REVIEW' ? 'badge-neon badge-neon-warning-outline' : '',
                                    dayTask.taskStatus === 'COMPLETED' ? 'badge-neon badge-neon-success-outline' : '',
                                ]"
                            />
                    <Button
                        class="qb-btn qb-btn-outline-sm"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#collapse' + dayTask.task.id + index"
                        ><font-awesome-icon icon="fa-solid fa-angle-down"
                    /></Button>
                </div>
            </div>

            <div class="collapse mb-2" :id="'collapse' + dayTask.task.id + index">
                <div class="p-2">
                    <div class="card-box">
                        <div class="row align-items-center my-1">
                            <div class="col-12">
                                <div class="mb-3" v-if="dayTask.status">
                                    <p class="task--title">Completion Date:</p>
                                    <p class="task--subtitle">{{ formatDate(dayTask.completedDate) }}</p>
                                </div>
                                <div class="mb-3" >
                                    <p class="task--title">Estimated Duration:</p>
                                    <p class="task--subtitle">{{ dayTask.task.estimatedTime ? estimate(dayTask.task.estimatedTime) : 'No estimation time given'}}</p>
                                    <!-- {{dayTask.taskStatus}} -->
                                </div>
                                
                                <p class="task--title">Task Description:</p>
                                <div class="task--description" v-html="dayTask.task.description"></div>

                                <div
                                    class="row gap-2 mt-3 mb-3"
                                    v-if="dayTask.taskStatus === 'NOT_YET_STARTED' || dayTask.taskStatus === 'REVERTED'"
                                >
                                    <Input
                                        placeholder="Paste the link"
                                        v-if="dayTask.task.submissionType === 'LINK'"
                                        type="link"
                                        v-model="submissionLink"
                                    />
                                    <Button
                                        label="Mark as complete"
                                        :disabled="!checkUrl && dayTask.task.submissionType === 'LINK'"
                                        @onClick="completeTaskHandler(dayTask)"
                                        class="qb-btn qb-btn-black-sm col-3 mx-3"
                                    />
                                </div>
                                <div
                                    class="mb-3"
                                    v-else-if="
                                        (dayTask.taskStatus === 'COMPLETED' || dayTask.taskStatus === 'IN_REVIEW') &&
                                        dayTask.task.submissionType === 'LINK'
                                    "
                                >
                                    <p class="task--title">Submitted Resource:</p>
                                    <a class="task--subtitle" :href="dayTask.link" target="_blank">{{
                                        dayTask.link
                                    }}</a>
                                </div>
                                <div class="mb-3" v-if="dayTask.task.submissionType === 'LINK'">
                                    <p class="task--title">Submission Count: {{dayTask.submissionCount}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from './ButtonComponent.vue';
import Badge from './BadgeComponent.vue';
import Input from './TextFieldComponent.vue';

export default {
    name: 'ContentListComponent',
    data() {
        return {
            submissionLink: '',
            checkUrl: false,
        };
    },
    props: {
        index: {
            type: Number,
        },
        dayTask: {
            type: Object,
        },
        day: {
            type: Object,
        },
    },
    components: {
        Button,
        Badge,
        Input,
    },
    computed: {
        checkIsUrlOrNot() {
            if (this.dayTask.task.submissionType === 'LINK') {
                // var pattern ="/^(http|https):\/\/[w\d]+\.[\w](\/[\w\d]+)?$/"
                return this.submissionLink.includes('https://') || this.submissionLink.includes('http://');
            }
            return true;
        },
        //  estimate(val){
        //   console.log(val)
        //   return val;
        // }
        // },
        // checkSubmissionTypeUrlValidation() {
        //   if (this.dayTask.task.submissionType === "LINK") {
        //     return this.submissionLink === "";
        //   }
        //   return false;
        // },
    },
    methods: {
        showTaskPage(id) {
            this.$router.push({
                name: 'ModuleDayDetailPage',
                params: { dayId: id },
            });
        },
        edit() {
            this.$emit('onEdit', this.dayTask);
        },
        deletemodal(dayTask) {
            this.$emit('showDelete', dayTask);
        },
        completeTaskHandler(dayTask) {
            if (dayTask.task.submissionType === 'LINK') {
                this.$emit('completeTask', { dayTask, day: this.day, submissionLink: this.submissionLink });
                this.submissionLink=''
            } else {
                this.$emit('completeTask', { dayTask, day: this.day });
            }
        },
    },
    watch: {
        submissionLink(val) {
            const isValidUrl = (urlString) => {
                var urlPattern = new RegExp(
                    '^(https?://)?' +
                        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
                        '((\\d{1,3}\\.){3}\\d{1,3}))' +
                        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
                        '(\\?[;&a-z\\d%_.~+=-]*)?' +
                        '(\\#[-a-z\\d_]*)?$',
                    'i'
                );
                return urlPattern.test(urlString);
            };
            if (isValidUrl(val)) {
                this.checkUrl = true;
            } else {
                this.checkUrl = false;
            }
        },
    },
    created() {
        if (this.dayTask.link) {
            this.submissionLink = this.dayTask.link;
        }
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.card-box {
    background-color: $light-100;
    padding: 10px 15px;
    margin-left: 20px;
    border-radius: $field-border-radius;
}

.icon--arrow--right {
    cursor: pointer;
}

.task--title {
    font-weight: 600;
    font-size: 14px;
    margin: 0px;
    margin-bottom: 5px;
}

.task--subtitle {
    font-size: $font-size-md;
    margin: 0px;
    margin-bottom: 5px;
}

.fa-circle-check {
    color: $dark-200;
    margin-right: 5px;
    background-color: $light-100;
}

.task--description {
    font-size: 14px;
}

.task-detail-card {
    background-color: $white;
    padding: 8px 12px;
    border-radius: $field-border-radius;
    margin-bottom: 10px;
    margin-left: 20px;
    border: 1px solid $light-200;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

    &:hover {
        background-color: #fdfdfd;
    }
}

.task-timeline-title {
    font-size: $font-size-md;
    margin: 0px;
    margin-left: -17px;
}

.task-detail-title {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: $dark-400;
    margin-bottom: 0px;
}

.task-detail-subtitle {
    font-size: $font-size-sm;
    color: $light-600;
    font-weight: $font-weight-normal-1;
    margin-bottom: 0px;
}

.day--title {
    font-weight: 500;
    margin: 0px;
}

.check-logo-completed {
    filter: grayscale(0%);
    opacity: 100%;
}

.check-logo-incompleted {
    filter: grayscale(100%);
    opacity: 30%;
    width:20px;
    height:20px;
}

.check-logo-green{
    color:rgb(80, 178, 80);
    width:20px;
    height:20px;
}
// .card--collapse--bottom {
//   border: 1px solid $light-100;
// }
.check-logo-red{
    color:rgb(255, 91, 91);
    width:20px;
    height:20px;
}
.check-logo-yellow{
    color:  #fde98f;
    background: transparent;
    width:20px;
    height:20px;
}

.qb-btn {
    color: $white;
    border: none;
    font-weight: $font-weight-normal-2;
    border-radius: $button-border-radius;
    height: fit-content;
    padding: 6px 15px;

    &-outline {
        &-sm {
            background-color: $white;
            border: 1px solid $dark-fade;
            font-size: $font-size-sm;
            color: $dark-400;
        }
    }
}
</style>
